import { FormAdapterBase } from '../form-adapter-base';
import { FormGroup, FormControl } from '@angular/forms';

export class CurrentEntityStatusAdapter<T extends FormGroup> extends FormAdapterBase<T, FormGroup> {

    private currentStatusKey: string;

    private endDateKey: string;

    public constructor(
        form: T,
        basePath: string,
        currentStatusKey = 'isCurrent',
        endDateKey = 'endDate',
    ) {
        super(form, basePath);
        this.currentStatusKey = currentStatusKey;
        this.endDateKey = endDateKey;
    }

    public override apply(): void {
        const currentStatusControl = this.getTargetForm().get(this.currentStatusKey) as FormControl;
        this.toggleEndDateField(currentStatusControl!.value);
    }

    private toggleEndDateField(currentStatus: boolean): void {
        const endDateControl = this.getTargetForm().get(this.endDateKey) as FormControl;
        if (currentStatus && endDateControl.enabled) {
            endDateControl.setValue('');
            endDateControl.disable();
        } else if (!currentStatus && !endDateControl.enabled) {
            endDateControl.enable();
        }
    }
}
